export default __webpack_public_path__ + "static/processBannerSecond-41923fe033cf391be638b42adcec1408.png";